import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Principal.css';
import CONFIG from '../../config.js';
import PrincipalEstudiante from './PrincipalEstudiante.js';
import CalendarioResumenEventos from '../mensajes/CalendarioResumenEventos.js';
import Alertas from '../mensajes/Alertas.js';


const URL_INFO = `${CONFIG.API_URL}/info_principal_tutor.php`;
const URL_CALENDARIO = `${CONFIG.API_URL}/operarCalendario.php`;

function PrincipalTutor({rol, configuracion}) {
    const userId =localStorage.getItem('loggedUserId');
    const [eventos, setEventos] = useState([]);
    const loggeduserId =localStorage.getItem('loggedUserId');
    const [estudiantesACargo, setEstudiantesACargo] = useState([]);
    const kte= localStorage.getItem('kte');
		const [verEstudiante, setVerEstudiante] = useState(0);
    const defaultFilePerfil='https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png';
    
  

     useEffect(() => {
            obtenerEventos();
    }, []);

		useEffect(() => {
      localStorage.removeItem('kte');
			buscaInfoVinculacion();
		}, []);
    
		const buscaInfoVinculacion = () => {
        axios.get(`${URL_INFO}?id_tutor=${loggeduserId}&agrupado=1`)
            .then(res => {
                if (!res.data.error) { 
                    console.log('datos vinculo:',res.data.datos);
                    setEstudiantesACargo(res.data.datos);
                } else {
                    setEstudiantesACargo([]);
										console.log(res.data.mensaje);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const obtenerEventos = async () => {
        try {
            const res = await axios.get(URL_CALENDARIO);
            if (Array.isArray(res.data)) {
                // Aplicar filtros según el rol
                const eventosFiltrados = res.data.filter(evento => {
                    const esPropio = evento.creada_por == userId;
    
                let filtroPorRol = false;
                rol = parseInt(rol, 10);
                switch (rol) {
                        case 1:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 2:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 3:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 4:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 5:
                            filtroPorRol = ['todos', 'todosD', 'todosDC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            break;
                        case 6:
                            filtroPorRol = ['todos', 'todosD', 'todosDC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            break;
                        case 7:
                            filtroPorRol = ['todos', 'todosE', 'todosEC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            //console.log('rol 7, evento:', evento.tipo_recordatorio, 'filtroPorRol:', filtroPorRol);
                            break;
                        case 8:
                            filtroPorRol = ['todos', 'todosT','todosE', 'todoTC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            break;
                        case 9:
                            filtroPorRol = ['todos', 'todosD'].includes(evento.tipo_recordatorio);
                            break;
                        case 12:
                            filtroPorRol = ['todos', 'todosM'].includes(evento.tipo_recordatorio);
                            break;
                        default:
                            filtroPorRol = false;
                            break;
                    }
    
                    return esPropio || filtroPorRol;
                });
    
                setEventos(eventosFiltrados);
            } else {
                setEventos([]);
                console.error('La respuesta de la API no es un array:', res.data);
            }
        } catch (err) {
            console.error('Error al obtener eventos:', err);
        }
    };

    const mostrarNombre = (orden)=>{
			let nombre="";
			switch(orden){  
				case "S2":
					nombre='Sala de 2';
					break        
				case "S3":
					nombre='Sala de 3';
				break
				case "S4":
					nombre='Sala de 4';
				break
				case "S5":
					nombre='Sala de 5';
				break
				case "In":
					nombre='Espacio Institucional';
				break
				default:
					nombre=orden+'°';
			}
			return nombre
		};
const seleccionarEstudiante= (est)=>{
  const fechaActual = new Date();
  localStorage.removeItem('kte');
  localStorage.setItem('kte',fechaActual+'&'+JSON.stringify(est)+'&'+loggeduserId);
  setVerEstudiante(est.estudiante_id);

}

    return (   
        <>
				{verEstudiante == 0 ?
				<>
          <h5>Área para tutores</h5>
          <div className='text-center'>
					{/* <button type="button" className="btn btn-primary">Inscribir un estudiante a mi cargo a un curso</button> */}
					</div>
					<hr/>
          <div className='row'>
            <div className='col-12 col-md-6 col-lg-4'>
              <div className='card px-2'>
                <div>
                  <p>tarjetas de alertas</p>
                    <Alertas userId={userId} rol={rol} />
                </div>
                <div className='mt-1'>
                  <CalendarioResumenEventos userId={userId} rol={rol} eventos={eventos} />
                </div>                   
              </div>
            </div>
            <div className='col-12 col-md-6 col-lg-8'>
              <div className='card px-4 pb-4'>
                <h5 className='mt-2'>Estudiantes vinculados</h5>                        
                <div className=''>
											{estudiantesACargo.map((e)=>(
												<div key={e.estudiante_id} className='card shadow border-0 p-3 m-1 d-flex justify-content-center' style={{width:'13rem'}}>
                           <img 
                            id="imagen" 
                            className='imagen-circular-estudiante rounded-circle border border-black p-1' 
                            src={(e.imagen_perfil===''||e.imagen_perfil==null)? `${defaultFilePerfil}` : `${CONFIG.API_URL}/${e.imagen_perfil}`} 
                            />	
  												<div><strong>{e.nombre}, {e.apellido}</strong></div>
                          <div> cursando: <strong>{mostrarNombre(e.orden)} {e.denominacion}</strong></div>
													<div>
                            <button className='btn btn-sm btn-outline-primary mx-1' on onClick={()=>seleccionarEstudiante(e)}>Ver como {e.nombre}</button>
                          </div>
                        </div>
											))}
                </div>
              </div>                   
            </div>
          </div>
					</>
					:
					<PrincipalEstudiante 
            rol={rol} 
            configuracion={configuracion} 
            verTutor={verEstudiante} 
          />
					}
        </>                
     );
}

export default PrincipalTutor;